/**
 * The seven payment terms of a company (JBWEB-1268), in display order. The api
 * keeps the same list in utils/paymentTerms.js and refuses any other term: one
 * added here must be added there.
 *
 * `defaultLabel` is the French wording, for the places that have no language
 * at hand (the Activité formatter); screens read `companyBilling.paymentTerms`.
 */
export const PAYMENT_TERMS = [
  { key: 'onReceipt', days: 0, endOfMonth: false, defaultLabel: 'À réception' },
  { key: 'days15', days: 15, endOfMonth: false, defaultLabel: '15 jours' },
  { key: 'days30', days: 30, endOfMonth: false, defaultLabel: '30 jours' },
  {
    key: 'days30EndOfMonth',
    days: 30,
    endOfMonth: true,
    defaultLabel: '30 jours fin de mois',
  },
  { key: 'days45', days: 45, endOfMonth: false, defaultLabel: '45 jours' },
  {
    key: 'days45EndOfMonth',
    days: 45,
    endOfMonth: true,
    defaultLabel: '45 jours fin de mois',
  },
  { key: 'days60', days: 60, endOfMonth: false, defaultLabel: '60 jours' },
];

export const findPaymentTerm = (term) =>
  term
    ? (PAYMENT_TERMS.find(
        (candidate) =>
          candidate.days === term.days &&
          candidate.endOfMonth === term.endOfMonth,
      ) ?? null)
    : null;

export const isPaymentTermShape = (value) =>
  Boolean(value) &&
  typeof value === 'object' &&
  Number.isInteger(value.days) &&
  typeof value.endOfMonth === 'boolean';

export const paymentTermLabel = (term, language) => {
  const found = findPaymentTerm(term);
  if (!found) return null;
  return language
    ? language.getValue(
        `companyBilling.paymentTerms.${found.key}`,
        found.defaultLabel,
      )
    : found.defaultLabel;
};
